export const purchaseOrderTranslate = {
  status: "el estado",
  supplierId: "el proveedor",
  companyId: "la empresa",
  operativeUnitId: "la unidad operativa",
  warehouseId: "el almacén",
  projectId: "el proyecto",
  projectDestination: "el destino del proyecto",
  date: "la fecha",
  totalAmount: "el importe total",
  purchasedAt: "la fecha de compra",
  approvedAt: "la fecha de aprobación",
  approvedById: "el aprobador",
  addressName: "el nombre de la dirección",
  address: "la dirección",
  addressPostalCode: "el código postal",
  addressCity: "la ciudad",
  addressProvince: "la provincia",
  addressCountry: "el país",
  quantity: "la cantidad",
  quantityToReceive: "la cantidad pendiente de recibir",
  unitPrice: "el precio unitario",
  externalReference: "la referencia externa",
};
